export const templateHeader = ["顧客ID", "顧客名", "担当者ID", "メールアドレス"];
